import React, { useState } from 'react'

import './Nav.scss'

import menuData from './menuData'
import HamburgerClose from '../Assets/hamburger_close.svg'
import Sound from '../Assets/sound_black.svg'
import NoSound from '../Assets/nosound_black.svg'
import MenuItems from './MenuItems/MenuItems'

import Social from '../../Footer/Social/Social'
import Policy from '../../Footer/Policy/Policy'

function Nav({ activeSound, toggleSound, navOpen, toggleNav, targets, setClicked }) {

    const [menuOpen, setMenuOpen] = useState(navOpen)

    const closeMenu = () => {
        setMenuOpen(prev => !prev)
        setTimeout(() => {
            toggleNav()
        }, 1000)
    }

    const handleMovecamera = (name) => {
        setClicked({state: true, name:name})
        closeMenu()
    }

    return (
        <div className='banzai_nav' >
            <nav className={`banzai_nav__menu ${menuOpen ? 'openMenu' : 'closeMenu' }`}>
                <button className='banzai_nav__menu__hamburger' onClick={closeMenu}> 
                    <img src={HamburgerClose} alt='hamburger close' />
                </button>
                <button onClick={toggleSound} className='banzai_nav__menu__sound'>
                    <img src={ activeSound ? Sound : NoSound} alt='sound' />
                </button>
                <div className='banzai_nav__menu__info_container'>
                    <div className='banzai_nav__menu__info_container__top'>
                        <span className='banzai_nav__menu__info_container__top__info'>Menu</span>
                        <div className='banzai_nav__menu__info_container__top__menu_items'>
                            {menuData.map((item, index) => {
                                return (
                                    <MenuItems key={index} item={item} closeMenu={closeMenu} />
                                )
                            })}
                        </div>
                    </div>
                    
                    <div className='banzai_nav__menu__info_container__other_pages'>
                        {targets.map((target, index) => <button key={index} onClick={() => handleMovecamera(target.name)} >{target.name}</button>)}
                    </div>
                </div>
                <div className='banzai_nav_menu_mobile'>
                    <Social header={true} color={'black'} />
                    <Policy />
                </div>                
            </nav>
        </div>
    )
}

export default Nav